import React, { useState, useRef, useEffect } from "react";
import SmallScreenSidebar from "../SmallScreenSidebar";
import { AiOutlineBars } from "react-icons/ai";
import { GiConfirmed } from "react-icons/gi";
import { MyContextSupply } from "../../../Context";
import AddForm from "./AddForm";
import axios from "axios";
import Modal from "@mui/material/Modal";
import { toast } from "react-toastify";

const AdminAdd = () => {
  const { setIsAdminSidebarOpen, token } = MyContextSupply();
  const [productInfo, setProductInfo] = useState({
    shortTitle: "",
    longTitle: "",
    description: "",
    mrp: null,
    cost: null,
  });
  const [category, setCategory] = useState("");
  const [showImage, setShowImage] = useState("");
  const [tagline, setTagline] = useState("");
  const [cloudinaryImageFile, setCloudinaryImageFile] = useState("");
  const imageRef = useRef(null);
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const [openModel, setModelOpen] = useState(false);

  const { shortTitle, longTitle, description, mrp, cost } = productInfo;

  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  const OnSubmitUploadProduct = async (e) => {
    e.preventDefault();
    setIsUploadLoading(true);
    if (
      shortTitle !== "" &&
      longTitle !== "" &&
      description !== "" &&
      mrp !== null &&
      cost !== null &&
      category !== "" &&
      tagline !== "" &&
      cloudinaryImageFile !== ""
    ) {
      // below data and axios post creating for cloudinary image url;
      const formData = new FormData();
      const publicId = cloudinaryImageFile.name.split(".")[0];
      formData.append("file", cloudinaryImageFile);
      formData.append("public_id", publicId);
      formData.append("upload_preset", "stechnology");
      return await axios
        .post(
          "https://api.cloudinary.com/v1_1/stechnologyimages/image/upload/",
          formData
        )
        .then((res) => {
          if (res.status === 200) {
            if (res.data.secure_url) {
              axios
                .post(
                  "https://stechbackend-9r4c.onrender.com/admin/add/product",
                  {
                    url: res.data.secure_url,
                    category,
                    description,
                    tagline,
                    title: { shortTitle, longTitle },
                    price: { mrp, cost },
                  },
                  { headers: { Authorization: token }, withCredentials: true }
                )
                .then((response) => {
                  if (response.status === 201) {
                    setModelOpen(true);
                    setCategory("");
                    setShowImage("");
                    setCloudinaryImageFile("");
                    setTagline("");
                    imageRef.current.value = "";

                    e.target.reset();
                    setIsUploadLoading(false);
                  }
                })
                .catch((err) => {
                  const status = err.response.status;
                  const message = err.response.data.message;
                  if (status === 404) {
                    toast.warn(message, toastStyle);
                  } else if (status === 500) {
                    toast.warn(message, toastStyle);
                  } else {
                    toast.warn(message, toastStyle);
                  }
                  setIsUploadLoading(false);
                });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          setIsUploadLoading(false);
        });
    } else {
      setTimeout(() => {
        toast.warn("Please fill all the inputs", toastStyle);
        setIsUploadLoading(false);
      }, 5000);
    }
  };

  useEffect(() => {
    const auto = setTimeout(() => {
      setModelOpen(false);
    }, 2000);
    return () => {
      clearTimeout(auto);
    };
  }, [openModel]);
  console.log(isUploadLoading);
  return (
    <section className="main-prod">
      <SmallScreenSidebar />
      <button
        onClick={() => setIsAdminSidebarOpen(true)}
        className="smallsidebar-open-btn"
      >
        <AiOutlineBars />
      </button>
      <div className="deshboard-content-part">
        <h1>Add Products</h1>
        <section className="desh-main-display desh-main-display-and-add">
          <AddForm
            OnSubmitUploadProduct={OnSubmitUploadProduct}
            productInfo={productInfo}
            setProductInfo={setProductInfo}
            category={category}
            setCategory={setCategory}
            tagline={tagline}
            setTagline={setTagline}
            imageRef={imageRef}
            setCloudinaryImageFile={setCloudinaryImageFile}
            showImage={showImage}
            setShowImage={setShowImage}
            isUploadLoading={isUploadLoading}
          />
          <div
            className={`product-upload-success ${
              openModel && "show-product-upload-success"
            }`}
          >
            <div className="popup-image-uploading-success">
              <div className="product-uploaded-icon">
                <p>
                  <GiConfirmed />
                </p>
                <h2>Success</h2>
                <p className="text-ad-p-success">
                  Product Uploaded Successfully!
                </p>
                <button onClick={() => setModelOpen(false)}>Close</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default AdminAdd;
